import { ThemeIcon } from '@src/theme/ThemeIcon';
import type { IconProps } from '@src/components/icons/IconProps';

export function UserIcon({ className }: IconProps) {
  return (
    <ThemeIcon name="user" className={className} fallback={
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="8.5" r="3.5" />
      <path d="M5 19.5c1.3-3.2 3.8-4.8 7-4.8s5.7 1.6 7 4.8" />
    </svg>} />
  );
}
